import UsersList from './users-list.component';
import { BROKER_VENDOR_REPS_LIST_PAGE } from '../../constants/navigations';

export default [
  { path: BROKER_VENDOR_REPS_LIST_PAGE.path, name: 'usersList', component: UsersList, exact: true },
];
